<template>
  <div>
    <div class="table-toolbar">
      <span>{{ $t('admins.adminsNumber') }} {{ adminsDatasource.total }} </span>
      <div class="table-toolbar__group">
        <TableSearch :data-source="adminsDatasource"></TableSearch>
        <TableLimitSelector :data-source="adminsDatasource"></TableLimitSelector>
        <PrintBtn class="u-margin-left-toolbar"></PrintBtn>
        <DownloadBtn :data="adminsDatasource.docs"></DownloadBtn>
        <gl-button
          id="admin.btn-add"
          v-profile-guard="'views.admins.add'"
          color-primary
          :type="'button'"
          :text="$t('admins.addAdmin')"
          :icon-left="'glicon-user-thin-plus'"
          @onClick="goToCreate"
        ></gl-button>
      </div>
    </div>
    <Table :columns="adminsColumns" :data-source="adminsDatasource" @clickRow="goToEdit"></Table>
  </div>
</template>

<script>
import i18n from '@/i18n';
import Table from '@/components/Table/Table.vue';
import TableLimitSelector from '@/components/Table/TableLimitSelector.vue';
import TableSearch from '@/components/Table/TableSearch.vue';
import Column from '@/components/Table/Column';
import TableDatasource from '@/components/Table/TableDatasource.js';
import PrintBtn from '@/components/Commons/PrintBtn.vue';
import DownloadBtn from '@/components/Commons/DownloadBtn.vue';
import AdminsService from '@/services/admins.service.js';
import store from '@/store/index.js';
import { mapActions } from 'vuex';

const adminsDatasource = new TableDatasource({
  sort: 'name',
  async load(props) {
    const response = await AdminsService.fetchAdmins(props);
    return response.data;
  }
});

export default {
  name: 'Admins',
  components: {
    Table,
    TableLimitSelector,
    TableSearch,
    PrintBtn,
    DownloadBtn
  },
  data() {
    return {
      adminsColumns: [
        new Column({ value: 'name', label: 'nouns.firstName', sortable: true }),
        new Column({
          value: 'surname',
          label: 'nouns.surname',
          sortable: true
        }),
        new Column({ value: 'email', label: 'nouns.email', sortable: true }),
        new Column({
          value: 'role',
          label: 'nouns.role',
          sortable: true,
          valueParser: (value) => i18n.t(`nouns.roles.${value}`)
        }),
        new Column({
          value: 'isCreator',
          label: 'nouns.isCreator',
          sortable: true,
          valueParser: (value) => i18n.t(`nouns.${value ? 'yes' : 'no'}`)
        }),
        new Column({
          value: 'blocked',
          label: 'nouns.status',
          sortable: true,
          valueParser: (blocked) => {
            return i18n.t(blocked ? 'admins.status.blocked' : 'admins.status.active');
          }
        }),
        new Column({
          cellRenderer(h) {
            return h('a', {
              class: ['un-btn'],
              domProps: { text: this.column.getValue(this.data) },
              on: {
                click: async (ev) => {
                  ev.stopPropagation();
                  await store.dispatch('resendEmail', this.data);
                }
              }
            });
          },
          action: 'components.adminTable.resendEmail',
          valueParser: () => i18n.t('actions.sendWelcome')
        })
      ],
      adminsDatasource
    };
  },
  methods: {
    ...mapActions(['resendEmail']),
    goToCreate() {
      this.$router.push({ name: 'adminCreate' });
    },
    goToEdit(rowData) {
      this.$router.push({ name: 'adminEdit', params: { id: rowData.id } });
    }
  }
};
</script>
